var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7106 1.65636C10.6418 1.65636 11.2785 6.01006 11.2785 6.01006V10.5339H20.8539V11.9521H7.46515C7.46515 11.9521 1.01968 11.1579 1.01968 21.3757C1.01968 31.5934 6.7107 31.1779 6.7107 31.1779H9.99654V26.4115C9.99654 26.4115 9.81218 20.7205 15.5273 20.7205H25.1168C25.1168 20.7205 30.466 20.8056 30.466 15.5414V6.9035C30.466 6.9035 31.2772 1.63934 20.7631 1.63934L20.7106 1.65636ZM15.4181 4.68694C15.7585 4.67835 16.0938 4.7709 16.3816 4.95289C16.6694 5.13488 16.8968 5.39813 17.035 5.70934C17.1732 6.02056 17.216 6.36577 17.158 6.70131C17.1 7.03686 16.9438 7.34766 16.7091 7.59442C16.4744 7.84118 16.1719 8.0128 15.8397 8.0876C15.5075 8.16239 15.1606 8.13699 14.8428 8.01461C14.525 7.89223 14.2507 7.67837 14.0545 7.40006C13.8582 7.12176 13.749 6.79152 13.7404 6.45111V6.42274C13.7404 5.96614 13.9218 5.52824 14.2447 5.20537C14.5676 4.8825 15.0055 4.70112 15.4621 4.70112L15.4181 4.68694Z",
    fill: "url(#paint0_linear_24_473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9942 41.095C31.0631 41.095 30.4263 36.7271 30.4263 36.7271V32.2174H20.8524V30.7992H34.2823C34.2823 30.7992 40.7277 31.5196 40.7277 21.3615C40.7277 11.2033 35.0367 11.5593 35.0367 11.5593H31.7083V16.2633C31.7083 16.2633 31.8927 21.9543 26.1776 21.9543H16.5838C16.5838 21.9543 11.2303 21.8734 11.2303 27.1376V35.8336C11.2303 35.8336 10.4191 41.0978 20.9333 41.0978H20.99L20.9942 41.095ZM26.2868 38.0502C25.9463 38.0588 25.611 37.9662 25.3232 37.7843C25.0354 37.6023 24.808 37.339 24.6698 37.0278C24.5317 36.7166 24.4889 36.3714 24.5469 36.0358C24.6049 35.7003 24.7611 35.3895 24.9958 35.1427C25.2304 34.896 25.533 34.7243 25.8652 34.6495C26.1974 34.5747 26.5443 34.6001 26.8621 34.7225C27.1798 34.8449 27.4542 35.0588 27.6504 35.3371C27.8466 35.6154 27.9559 35.9456 27.9644 36.286V36.3286C27.9644 36.7852 27.783 37.2231 27.4602 37.5459C27.1373 37.8688 26.6994 38.0502 26.2428 38.0502H26.2868Z",
    fill: "url(#paint1_linear_24_473)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_473",
    x1: 4.94392,
    y1: 5.51783,
    x2: 23.7863,
    y2: 24.3176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_473",
    x1: 16.091,
    y1: 17.7645,
    x2: 37.6187,
    y2: 36.5585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.917,
    height: 40.917,
    fill: "white",
    transform: "translate(0.415222 0.910095)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonIcon);
export default __webpack_public_path__ + "static/media/python-icon.8932f63a6ca8766573ef0f40f7c14a57.svg";
export { ForwardRef as ReactComponent };